import React from 'react';
import { Form } from 'react-bootstrap';

const ReactstrapFormikCheckbox = ({ field: { ...fields }, ...props }) => {
    const { id, label } = props;
    return (
        <Form.Group controlId={id} className="form-group">
            <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id={id} checked={fields.value} {...fields} />
                <label className="custom-control-label pb-0" htmlFor={id}>
                    {label}
                </label>
            </div>
        </Form.Group>
    );
};
export default ReactstrapFormikCheckbox;
